import React from 'react';
import PropTypes from 'prop-types';
import {prune} from 'underscore.string';
import classNames from 'classnames';
import { ButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

export default class CustomButtonDropdown extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    caret: PropTypes.bool,
    className: PropTypes.string,
    color: PropTypes.string,
    dataTestId: PropTypes.string,
    displayTextMaxLength: PropTypes.number,
    hideLabelOnMobile: PropTypes.bool,
    isRightAligned: PropTypes.bool,
    noDisplayText: PropTypes.bool,
    showActive: PropTypes.bool,
    size: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.string,
  }

  static defaultProps = {
    caret: true,
    className: '',
    color: 'secondary',
    dataTestId: null,
    displayTextMaxLength: 1000,
    hideLabelOnMobile: false,
    isRightAligned: false,
    showActive: true,
    size: 'md',
    text: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      value: this.props.value || null,
    };
  }

  /**
   * Return a string to display as the button text
   */
  getDisplayText = () => {
    if (this.props.noDisplayText) {
      return '';
    }

    var fullString = this.props.showActive
      ? this.seekDisplayText(this.props.children, this.state.value) || this.props.text
      : this.props.text;

    return prune(fullString, this.props.displayTextMaxLength);
  }

  seekDisplayText = (children, selectedValue) => {
    const selected = children
      .filter(child => !!child)
      .find(child => child.props.val === selectedValue);

    if (!selected) {
      return;
    }

    return selected.props.displayText || selected.props.children || selectedValue;
  }

  /**
   * When dropdown button is clicked
   */
  onClick = (event) => {
    // Toggle open state
    this.setState({
      open: !this.state.open,
    });

    event.stopPropagation();
  }

  render() {
    const {caret, size, children, className, color, hideLabelOnMobile, isRightAligned, dataTestId} = this.props;
    const labelClasses = {'hidden-xs': hideLabelOnMobile};

    return (
      <ButtonDropdown
        className={className}
        isOpen={this.state.open}
        toggle={this.onClick}
      >
        <DropdownToggle
          caret={caret}
          color={color}
          data-test-id={dataTestId}
          size={size}
        >
          <span className={classNames(labelClasses)}>
            {this.getDisplayText()}
          </span>
        </DropdownToggle>
        <DropdownMenu right={isRightAligned}>
          {children}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}
